export const NC_DASHBOARD = 'dashboard';
export const NC_ALERTS = 'alerts';
export const NC_ALERTS_DETAILS = 'details';
export const NC_ALERTS_NEW = 'new';
export const NC_NOTIFICATIONS = 'notifications';
export const NC_BREAKING_NEWS: string = 'breaking_news';
